// extracted by mini-css-extract-plugin
export default {"bordered":"dXtBUY2il687ZK9YMqPh"};